export default "__VITE_ASSET__D9iYjC47__"